import { SeatMapRestrictions } from '@websky/graphql';
import { clearPassengerFilters, setPassengerFilter } from './actions';
import { SeatMapAction, SeatMapState } from './types';
import produce from 'immer';

const initialState: SeatMapState = {
	activePassengerFilters: []
};

export const seatMapReducer = (state: SeatMapState = initialState, action: SeatMapAction) => {
	switch (action.type) {
		case setPassengerFilter.toString(): {
			const restriction = action.payload as SeatMapRestrictions;
			const activePassengerFilters = state.activePassengerFilters;

			if (activePassengerFilters?.includes(restriction)) {
				return produce(state, draft => {
					draft.activePassengerFilters = draft.activePassengerFilters.filter(
						filter => filter !== restriction
					);
				});
			}

			return produce(state, draft => {
				draft.activePassengerFilters.push(restriction);
			});
		}

		case clearPassengerFilters.toString(): {
			return produce(state, draft => {
				draft.activePassengerFilters = [];
			});
		}

		default:
			return state;
	}
};
